<template>
    <div class="modal fade" ref="trainingModal" id="training-modal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="px-3 px-xl-6">
                        <a type="button" class="modal-close-btn" data-dismiss="modal">
                            <img src="/images/global/close-icon.svg">
                        </a>
                        <div class="text-center">
                            <p>ACG Credit Card Required Annual Training</p>
                            <a href="/landing/annual-training">Click Here to Complete Now</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    mounted() {
        $(this.$refs.trainingModal).modal('show');
    }
}
</script>
